// @ts-nocheck
import {
  Box,
  Grid,
  Heading,
  MapPinIcon,
  MicrophoneIcon,
  PaletteIcon,
  Stack,
  Text,
  TimelineIcon,
} from "@smoothie-framework/ui";
import { AnimatedSvgImage, Gutter } from "./shared";

const referenceCards = [
  [MicrophoneIcon, "Voices", "Capture tone, accent and delivery for each character."],
  [
    PaletteIcon,
    "Visual style",
    "Collect the palette, lighting and visual references for your series.",
  ],
  [
    MapPinIcon,
    "Environments",
    "Define recurring places, their atmosphere and distinctive details.",
  ],
  [
    TimelineIcon,
    "Continuity",
    "Track events, relationships and what each character knows.",
  ],
] as const;

export function StoryBible() {
  return (
    <Box
      as="section"
      className="storybible section-warm"
      py={{ base: 16, md: 22 }}
    >
      <Gutter>
        <Grid
          alignItems={{ base: "stretch", md: "end" }}
          columns={{ base: 1, md: "1fr 1.2fr" }}
          gap={{ base: 8, md: 20 }}
        >
          <Stack gap={4}>
            <Text className="eyebrow" color="accent" textStyle="meta">
              STORYBIBLE
            </Text>
            <Heading level={2} textStyle="h1">
              One story world.
              <br />
              Across every episode.
            </Heading>
          </Stack>
          <Box maxW={170}>
            <Text
              as="p"
              color="subtle"
              mt={{ base: 5, md: 0 }}
              textStyle="body"
            >
              Keep the details that shape your story in one place — from
              character histories and world rules to voices, environments and
              visual references. Your StoryBible guides both the writing and the
              look of every episode.
            </Text>
          </Box>
        </Grid>
      </Gutter>
      <Gutter>
        <Grid
          columns={{ base: 1, lg: 2 }}
          gap={{ base: 5, md: 6 }}
          mt={{ base: 11, md: 18 }}
        >
          <Stack
            className="bible-card context-card"
            background="surface1"
            border="sm"
            borderColor="border"
            gap={6}
            overflow="hidden"
            p={7}
            rounded="3xl"
          >
            <AnimatedSvgImage
              alt="Story context and canon"
              height={348}
              image="storybible/workspace-overview.svg"
              width={572}
            />
            <Stack gap={2}>
              <Text as="strong" color="inverse" textStyle="h3">
                Story context &amp; canon
              </Text>
              <Text as="p" color="inverse" textStyle="body-sm">
                Keep the premise, world rules and established events together as
                your story develops.
              </Text>
            </Stack>
          </Stack>
          <Stack
            className="bible-card character-card"
            background="surface1"
            border="sm"
            borderColor="border"
            gap={6}
            overflow="hidden"
            p={7}
            rounded="3xl"
          >
            <AnimatedSvgImage
              alt="Elin Voss character workspace"
              height={348}
              image="storybible/workspace-character.svg"
              width={572}
            />
            <Stack gap={2}>
              <Text as="strong" textStyle="h3">
                Characters &amp; relationships
              </Text>
              <Text as="p" color="subtle" textStyle="body-sm">
                Define who your characters are, what they want and how their
                relationships shape the story.
              </Text>
            </Stack>
          </Stack>
        </Grid>
      </Gutter>
      <Gutter>
        <Grid columns={{ base: 2, lg: 4 }} gap={6} mt={{ base: 6, md: 10 }}>
          {referenceCards.map(([Icon, title, copy]) => (
            <Stack
              as="article"
              background="surface1"
              border="sm"
              borderColor="border"
              key={title}
              minH={70}
              p={{ base: 4.5, lg: 6 }}
              justify="between"
              rounded="md"
            >
              <Box
                as="span"
                border="sm"
                borderColor="border"
                color="accent"
                display="grid"
                h={10}
                placeItems="center"
                rounded="md"
                w={10}
              >
                <Icon size="md" />
              </Box>
              <Stack gap={2.5}>
                <Text as="strong" textStyle="h3">
                  {title}
                </Text>
                <Text as="p" textStyle="body-sm" color="subtle">
                  {copy}
                </Text>
              </Stack>
            </Stack>
          ))}
        </Grid>
      </Gutter>
    </Box>
  );
}
